
export const appointments = {
  upcomingAppointments: "Upcoming Appointments",
  pastAppointments: "Past Appointments",
  loading: "Loading...",
  noUpcomingAppointments: "You have no upcoming appointments",
  bookNow: "Book an appointment now to connect with the expert",
  goodToKnow: "Good to know",
  tips: {
    joinEarly: "Join your consultation sessions 5 minutes early",
    cancellation: "Cancellation is possible up to 24 hours before the appointment",
    contact: "In case of any problems, please contact customer service"
  },
  details: "Details",
  joinMeeting: "Join the meeting",
  topic: "Topic",
  note: "Note",
  duration: "minutes",
  status: {
    new: "New",
    accepted: "Accepted",
    completed: "Completed",
    rejected: "Rejected"
  }
};
